import { Favorite, Filter } from 'grommet-icons';
import styled, { css } from 'styled-components';

const filledIcon = css`
  path[fill='none'] {
    fill: rgb(229 36 59) !important;
  }
  polygon[fill='none'] {
    fill: rgb(229 36 59) !important;
  }
`;

interface FilledIconProps {
  filled?: string;
}

// @ts-expect-error - @types/styled-components bundles its own @types/react, which conflicts
// with this app's @types/react and breaks styled()'s overload resolution for grommet-icons
export const FavoriteFilled = styled(Favorite)<FilledIconProps>`
  ${(props) => (props.filled ? filledIcon : '')}
`;

// @ts-expect-error - same duplicate @types/react conflict as FavoriteFilled above
export const FilterFilled = styled(Filter)<FilledIconProps>`
  ${(props) => (props.filled ? filledIcon : '')}
`;
